// extracted by mini-css-extract-plugin
export default {"fullWidth":"LoanProgramDetailsFields_fullWidth__CvOrB"};